import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import ProcessedOutput from "../../pages/ProcessedOutput";
import { Stack, Button, Paper } from "@mui/material";
import { toast } from "react-toastify";

export default function BulkReview() {
  const { roomId } = useParams();
  const [searchParams] = useSearchParams();
  const index = parseInt(searchParams.get("index") || "0", 10);
  const navigate = useNavigate();

  const queueKey = `bulk_review_queue_${roomId}`;
  const queue = JSON.parse(sessionStorage.getItem(queueKey) || "[]");
  console.log("Queue loaded from sessionStorage:", queue);
  const failedVideosKey = `failed_videos_${roomId}`;
  const failedVideos = JSON.parse(
    sessionStorage.getItem(failedVideosKey) || "[]"
  );

  const handleNext = () => {
    if (index + 1 < queue.length) {
      navigate(`/bulk-review/${roomId}?index=${index + 1}`);
    } else {
      alert("All videos reviewed!");
      navigate("/add-video");
    }
  };

  const handlePrev = () => {
    if (index > 0) {
      navigate(`/bulk-review/${roomId}?index=${index - 1}`);
    }
  };

  const handleDownloadFailed = () => {
    const failedVideosKey = `failed_videos_${roomId}`;
    const failedVideos = JSON.parse(
      sessionStorage.getItem(failedVideosKey) || "[]"
    );
    console.log("Failed videos loaded from sessionStorage:", failedVideos);
    if (!failedVideos || failedVideos.length === 0) {
      toast.error("No failed videos to download.");
      return;
    }

    const lines = failedVideos.map((v) => `${v.filename}: ${v.error}`);
    const textContent = lines.join("\n");

    const blob = new Blob([textContent], { type: "text/plain;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `failed_videos_${roomId}.txt`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const currentVideoId = queue[index];

  return (
    <>
      {queue.length > 0 ? (
        <ProcessedOutput key={currentVideoId} video_id={currentVideoId} />
      ) : (
        <p style={{ textAlign: "center", marginTop: "20px" }}>
          No videos found for review.
        </p>
      )}

      <Paper
        elevation={3}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          zIndex: 1300,
          py: 1,
          backgroundColor: "#fff",
          borderTop: "1px solid #ddd",
        }}
      >
        <Stack direction="row" spacing={2} justifyContent="center">
          {queue.length > 0 && (
            <>
              <Button
                variant="contained"
                onClick={handlePrev}
                disabled={index === 0}
                color="primary"
              >
                Previous
              </Button>
              <Button
                variant="contained"
                onClick={handleNext}
                disabled={index === queue.length - 1}
                color="primary"
              >
                Next
              </Button>
            </>
          )}
          {failedVideos.length > 0 && (
            <Button
              variant="outlined"
              onClick={handleDownloadFailed}
              color="error"
            >
              Download Failed Videos
            </Button>
          )}
        </Stack>
      </Paper>
    </>
  );
}
